module.exports = __webpack_public_path__ + "img/item-1.38d8675.svg";